import Highcharts from 'highcharts';
import { getTowingData } from "./chart-towing";

/**
 * @param {string} id
 */
export default function chartWrecks(id) {
    if (!document.getElementById(id)) return;

    // Sort by wrecks per 100k
    const cityData = getTowingData().sort((a, b) => b.wrecksPer100k - a.wrecksPer100k);

    const categories = cityData.map(item => item.city);
    const wrecksData = cityData.map(item => item.wrecksPer100k);

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Usunięte wraki na 100 tys. mieszkańców' },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            min: 0,
            title: { text: 'Liczba wraków' }
        },
        tooltip: {
            shared: true,
            pointFormat: '<b>{point.y}</b> wraków na 100k mieszkańców'
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: true
                },
                borderRadius: 4
            }
        },
        legend: { enabled: false },
        credits: { enabled: false },
        series: [{
            name: 'Usunięte wraki',
            data: wrecksData,
            color: '#7f8c8d'
        }]
    });
}
